import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';

const Container = styled.div`
  display: flex;
  overflow-x: auto;
  height: 70px;
`;

const Label = styled.td`
  font-weight: 400;
  font-size: 10px;
  color: #626469;
`;

const NumbersTable = styled.table`
  position: relative;
  display: table;
  border-collapse: collapse;
`;

const NumbersTableBody = styled.tbody``;

const NumbersTableRow = styled.tr``;

const LabelsWrapper = styled.tr`
  position: absolute;
  bottom: -20px; left: 0px; right: 0px;
  display: flex;
  justify-content: space-between;
`;

const NumberWrapper = styled.td`
  text-align: center;
  vertical-align: middle;
  width: 35px;
  min-width: 35px;
  max-width: 35px;
  height: 35px;
  min-height: 35px;
  max-height: 35px;
  border: 1px solid #626469;
  font-weight: 700;
  font-size: 12px;
  ${props => props.selected ? `color: white; background-color: #626469;` : `color: #626669;`}
  cursor: pointer;
`;

class SurveyGrade extends React.Component {

  static propTypes = {
    value: PropTypes.number,
    getLabel: PropTypes.func,
    onChange: PropTypes.func,
  }

  buildNumbers = () => {
    const components = [];
    for (let i = 0; i < 10; i++) {
      components.push(<NumberWrapper selected={this.props.value === (i + 1)} onClick={() => { this.props.onChange(i + 1); }}>{i + 1}</NumberWrapper>);
    }

    return components;
  }

  render = () => {
    return (
      <Container>
        <Scrollbars>
          <NumbersTable>
            <NumbersTableBody>
              <NumbersTableRow>
                {this.buildNumbers().map((c, idx) => <React.Fragment key={idx}>{c}</React.Fragment>)}
              </NumbersTableRow>
              <LabelsWrapper>
                <Label>{this.props.getLabel('embedded_survey.not_at_all_likely')}</Label>
                <Label>{this.props.getLabel('embedded_survey.completely_likely')}</Label>
              </LabelsWrapper>
            </NumbersTableBody>
          </NumbersTable>
        </Scrollbars>
      </Container>
    );
  }
}

export default SurveyGrade;
